export default "__VITE_ASSET__owLYTqwH__"